import { createGlobalStyle } from "styled-components";
import { FontSize } from "@glossy";

// Linkfluence custom reset stylesheet, based on http://meyerweb.com/eric/tools/css/reset/
export default createGlobalStyle`
  html,
  body,
  button,
  div,
  span,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    vertical-align: baseline;
    box-sizing: border-box;
  }

  html,
  body,
  #main {
    height: 100%;
  }

  body {
    line-height: 1.5;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    font-size: ${FontSize.Medium};
  }

  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  ol,
  ul {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: "";
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  *:focus {
    outline: none;
    box-shadow: none;
  }

  input {
    cursor: auto;
    border: none;
  }

  input[type="text"]::-ms-clear {
    display: none;
  }

  textarea {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  a {
    cursor: pointer;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  dl,
  dt,
  dd {
    margin: 0;
  }

  button::-moz-focus-inner {
    border: 0;
  }

  /* @tootools/emoji replaces emojis with img.emoji elements */
  img.emoji {
    height: 1em;
    width: 1em;
    margin: 0 .05em 0 .1em;
    vertical-align: -.1em;
    display: inline-block;
  }
`;
